import { useState, useEffect } from "react";
import { Box, Modal, Stack, Button, TextField } from "@mui/material";
import { CheckCircleOutline, HighlightOff, ErrorOutline as ErrorOutlineIcon, Info as InfoIcon } from '@mui/icons-material';

const AlertPopupModal = (props) => {
    const [modal, setModel] = useState({ ...props.props });
    const [validate, setValidate] = useState(false);
    const [txtReason, setTxtReason] = useState('');

    useEffect(() => {
        setValidate(false);
        setModel(props.props);
        setTxtReason('');
    }, [props.props]);

    const checkTxtReason = () => {
        if (modal.text != undefined && modal.text.status === true && modal.text.null != undefined && modal.text.null === 'notnull') {
            if (!txtReason || txtReason.replace(/\s+/g, '') == '') {
                setTxtReason('');
                setValidate(true);
                return false;
            } else {
                setValidate(false);
                return true;
            }
        } else {
            setValidate(false);
            return true;
        }
    }

    const style = {
        maincontainer: {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: (props.width) ? props.width : '500px',
            '@media(max-width: 400px)': {
                width: '100%'
            },
            border: '1px solid',
            borderColor: 'boderColor.default',
            bgcolor: 'background.paper',
            borderRadius: '8px',
            boxShadow: 24,
            p: 4
        },
        icon: {
            textAlign: 'center',
            paddingBottom: '30px'
        },
        iconSize: {
            fontSize: '70px',
        },
        contain: {
            textAlign: 'center',
            fontSize: '21px',
            fontWeight: 'bold',
            paddingBottom: '10px'
        },
        textDetail: {
            textAlign: 'center',
            fontSize: '16px',
            paddingBottom: '20px'
        },
        btn: {
            fontFamily: 'Calibri, Phetsarath OT',
            fontSize: '14px',
            width: '100px',
        }
    };

    // Icon condition
    var alertIcon = '';
    if (modal.status === 'primary') {
        alertIcon = <CheckCircleOutline color={modal.status} sx={style.iconSize} />
    } else if (modal.status === 'warning') {
        alertIcon = <ErrorOutlineIcon color={modal.status} sx={style.iconSize} />
    } else if (modal.status === 'info') {
        alertIcon = <InfoIcon color={modal.status} sx={style.iconSize} />
    } else {
        alertIcon = <HighlightOff color={modal.status} sx={style.iconSize} />
    }

    return (
        <div tabIndex='0' onKeyDown={(e) => {
            if (e.key == 'Enter') {
                setModel({ open: false });
                //props.callback();
            }
        }}>
            <Modal
                open={modal.open}
            >
                <Box sx={style.maincontainer}>
                    <Box sx={style.icon}>
                        {alertIcon}
                    </Box>
                    <Box sx={style.contain}>
                        {modal.message}
                    </Box>
                    <Box sx={style.textDetail}>
                        {modal.message_detail}
                    </Box>
                    {
                        (modal.text != undefined && modal.text.status != undefined && modal.text.status === true) &&
                        <Box>
                            <TextField
                                label={
                                    (modal.text != undefined
                                        && modal.text.label != undefined
                                        && modal.text.label != '') ? modal.text.label : ''
                                }
                                value={txtReason}
                                onChange={(e) => setTxtReason(e.target.value)}
                                error={validate}
                                //helperText={FrmValidation.msg(validateVal, "detail")}
                                rows={2}
                                multiline
                                size="small"
                                variant="outlined"
                                fullWidth
                                inputProps={{ maxLength: 100 }}
                            />
                        </Box>
                    }
                    <Box sx={{ flexGrow: 1, paddingTop: '20px' }}>
                        <Stack
                            direction="row"
                            justifyContent="center"
                            alignItems="center"
                            spacing={1}
                        >
                            {
                                /**
                                 *  Button default if not custom
                                 */
                                modal.btn === undefined && (
                                    <Button
                                        color={modal.status}
                                        variant="contained"
                                        className="font-family btn-manage"
                                        onClick={() => { setModel({ open: false }) }}
                                    >
                                        ຕົກລົງ
                                    </Button>
                                )
                            }
                            {
                                /**
                                 *  Button action1 custom
                                 */
                                modal.btn != undefined && modal.btn.btnAction1 != undefined && modal.btn.btnAction1.status === true && (
                                    <Button
                                        color={(modal.btn.btnAction1.color) ? modal.btn.btnAction1.color : modal.status}
                                        variant="contained"
                                        className="font-family btn-manage"
                                        onClick={() => {
                                            if (checkTxtReason()) {
                                                modal.btn.btnAction1.func(txtReason);
                                            }
                                        }}
                                    >
                                        {modal.btn.btnAction1.txt}
                                    </Button>
                                )
                            }

                            {
                                /**
                                 *  Button action2 custom
                                 */
                                modal.btn != undefined && modal.btn.btnAction2 != undefined && modal.btn.btnAction2.status === true && (
                                    <Button
                                        //color={modal.status}
                                        color={(modal.btn.btnAction2.color) ? modal.btn.btnAction2.color : modal.status}
                                        variant="contained"
                                        className="font-family btn-manage"
                                        onClick={modal.btn.btnAction2.func}
                                    >
                                        {modal.btn.btnAction2.txt}
                                    </Button>
                                )
                            }

                            {
                                /**
                                 *  Link button custom
                                 */
                                modal.btn != undefined && modal.btn.link != undefined && modal.btn.link.status === true && (
                                    <Button
                                        //color={modal.status}
                                        color={(modal.btn.link.color) ? modal.btn.link.color : modal.status}
                                        variant="contained"
                                        className="font-family btn-manage"
                                        href={modal.btn.link.href}
                                    >
                                        {modal.btn.link.txt}
                                    </Button>
                                )
                            }

                            {
                                /**
                                 *  Button cancel custom
                                 */
                                modal.btn != undefined && modal.btn.btnCancel != undefined && modal.btn.btnCancel.status === true && (
                                    <Button
                                        color={modal.status}
                                        variant="outlined"
                                        className="font-family btn-manage"
                                        onClick={modal.btn.btnCancel.func}
                                    >
                                        {modal.btn.btnCancel.txt}
                                    </Button>
                                )
                            }
                        </Stack>
                    </Box>
                </Box>
            </Modal >
        </div>
    )
}
export default AlertPopupModal